import { FormControl } from '@angular/forms';
import * as moment_ from 'moment';

const moment = moment_;

export function dateFormatValidator(control: FormControl): { [invalidFormatDate: string]: boolean } {
  let date;
  const dateFormatPattern = /^\d{1,2}\/\d{1,2}\/\d{4}$/;

  if (!control.value.match(dateFormatPattern)) {
    return { invalidFormatDate: true };
  }

  date = moment(control.value, 'DD/MM/YYYY', true);

  if (!date.isValid()) {
    return { invalidFormatDate: true };
  }
}
